import React from 'react'
import BaseIcon from 'react-icon-base'

const LA = props => (
  <BaseIcon width={21} height={15} viewBox="0 0 21 15" {...props}>
    <title>LA</title>
    <defs>
      <rect id="a" width="21" height="15" rx="2" />
      <rect id="c" width="20" height="14" x=".5" y=".5" rx="2" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <mask id="b" fill="#fff">
        <use xlinkHref="#a" />
      </mask>
      <use fill="#00297B" xlinkHref="#a" />
      <g fillRule="nonzero" mask="url(#b)">
        <g transform="translate(-1)">
          <path fill="#CE1126" d="M0 0h22.5v15H0z" />
          <path fill="#002868" d="M0 3.75h22.5v7.5H0z" />
          <circle cx="11.25" cy="7.5" r="3" fill="#FFF" />
        </g>
      </g>
      <use stroke="#2F343A" strokeOpacity=".157" xlinkHref="#c" />
    </g>
  </BaseIcon>
)

export default LA
